import { render } from "./goodsRestrictions.vue?vue&type=template&id=40247837&scoped=true"
import script from "./goodsRestrictions.vue?vue&type=script&lang=js"
export * from "./goodsRestrictions.vue?vue&type=script&lang=js"

import "./goodsRestrictions.vue?vue&type=style&index=0&id=40247837&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40247837"]])

export default __exports__